Namespace 'Monitoring.Views.SocialContents'

class Monitoring.Views.SocialContents.SessionListView extends Backbone.View
  template: JST['backbone/templates/monitoring/sessions/session_list']

  events:
    'click .owned-session .details' : 'restoreSession'
    'click .remove_session'         : 'removeSession'
    'click .copy_session'           : 'copySession'
    'click .remove_all_session'     : 'removeAllSessions'
    'input #session-search'   : 'searchSessions'

  initialize: (@options = {}) ->
    @sessions = @options.sessions
    @users = @options.users
    @canDelete = true

  render: ->
    @$el.html @template
      hasSessions: @sessions.length
    @_renderSessionListItems()
    @

  _renderSessionListItems: ->
    $list = @$('.session-list-items')
    $list.append $('<div></div>')
    $list.append(@_sessionListItemHTML(session)) for session in @sessions

  _sessionListItemHTML: (session) ->
    new Monitoring.Views.SocialContents.SessionListItemView(session: session).render().el

  restoreSession: (event) =>
    @restoreSessionFromSession(@_getSession(event))
    #@eventAggregator.trigger('clickOnRestoreSession', @_getSession(event), => @trigger('destroyFromRestore'))

  restoreSessionFromSession: (session) =>
    @eventAggregator.trigger('clickOnRestoreSession', session , => @trigger('destroyFromRestore'))

  removeSession: (event) =>
    return unless @canDelete
    swal
      title: I18n.t 'monitoring.dashboard.session.modal_delete'
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t 'monitoring.dashboard.session.s_yes'
      cancelButtonText: I18n.t 'monitoring.dashboard.session.s_cancel'
      closeOnConfirm: true
      =>
        @canDelete = false
        @eventAggregator.trigger('clickOnRemoveSession', @_getSession(event))

  removeAllSessions: (event) =>
    swal
      title: I18n.t 'monitoring.dashboard.session.modal_delete_all'
      type: 'warning'
      showCancelButton: true
      confirmButtonClass: 'btn-danger'
      confirmButtonText: I18n.t 'monitoring.dashboard.session.s_yes'
      cancelButtonText: I18n.t 'monitoring.dashboard.session.s_cancel'
      closeOnConfirm: true
      => @eventAggregator.trigger 'removeAllSessions'

  copySession: (event) =>
    @_triggerModalOpened()
    session = @_getSession(event)
    copySessionModal = new Monitoring.Views.SocialContents.CopySessionView(session: session).render()
    copySessionModal.bind 'onSuccess', (response) =>
      copySessionModal.clear()
    @$el.find('#copy_session_modal').html(copySessionModal.el)
    copySessionModal.show()

  searchSessions: (event) =>
    inputValue = $(event.target).get(0).value
    sessions = @$el.find('.saved-session')
    $(session).toggle(@_sessionNameMatches(session, inputValue)) for session in sessions

  _getSession: (event) ->
    listEl = $(event.target).parents('.saved-session')
    uuid = listEl.data('uuid')
    _.find(@sessions, (session) -> session.uuid == uuid)

  _triggerModalOpened: ->
    setTimeout () ->
      Backbone.trigger('copySessionModal:opened')
    , 100

  _sessionNameMatches: (session, text) ->
    @_sessionName(session).toUpperCase().indexOf(text.toUpperCase()) != -1

  _sessionName: (session) ->
    $(session).find('.name').text().trim()
